var utils = require( './utils' );

var footer_nav = ( function( $ ) {

	var $footer;

	var _init = function() {
		$footer = $( '#footer' );

		$footer.find( '.footer-title' ).on( 'click', _toggle_footer_nav );
	};

	var _toggle_footer_nav = function() {
		if ( utils.viewport_size().width >= 992 )  {
			return;
		}

		var $this = $( this );

		$this.toggleClass( 'open' );
		$this.next().slideToggle();
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = footer_nav;